export var VehicleType;
(function (VehicleType) {
    VehicleType[VehicleType["Car"] = 1] = "Car";
    VehicleType[VehicleType["Truck"] = 2] = "Truck";
    VehicleType[VehicleType["SUV"] = 3] = "SUV";
    VehicleType[VehicleType["Van"] = 4] = "Van";
    VehicleType[VehicleType["Other"] = 5] = "Other";
    VehicleType[VehicleType["Motorcycle"] = 6] = "Motorcycle";
    VehicleType[VehicleType["ATV_UTV"] = 7] = "ATV_UTV";
    VehicleType[VehicleType["Coupe"] = 8] = "Coupe";
    VehicleType[VehicleType["EV"] = 9] = "EV";
})(VehicleType || (VehicleType = {}));
export var QuoteStatus;
(function (QuoteStatus) {
    QuoteStatus[QuoteStatus["None"] = 1] = "None";
    QuoteStatus[QuoteStatus["Pending"] = 2] = "Pending";
    QuoteStatus[QuoteStatus["Completed"] = 3] = "Completed";
    QuoteStatus[QuoteStatus["Expired"] = 4] = "Expired";
})(QuoteStatus || (QuoteStatus = {}));
export var Drivability;
(function (Drivability) {
    Drivability[Drivability["RideAndDrive"] = 1] = "RideAndDrive";
    Drivability[Drivability["Inoperational"] = 2] = "Inoperational";
})(Drivability || (Drivability = {}));
export var FuelType;
(function (FuelType) {
    FuelType[FuelType["Gasoline"] = 1] = "Gasoline";
    FuelType[FuelType["Diesel"] = 2] = "Diesel";
    FuelType[FuelType["Hybrid"] = 3] = "Hybrid";
    FuelType[FuelType["Electric"] = 4] = "Electric";
    FuelType[FuelType["Hydrogen"] = 5] = "Hydrogen";
    FuelType[FuelType["Other"] = 6] = "Other";
})(FuelType || (FuelType = {}));
export var GatePassType;
(function (GatePassType) {
    GatePassType[GatePassType["NotRequired"] = 1] = "NotRequired";
    GatePassType[GatePassType["Pending"] = 2] = "Pending";
    GatePassType[GatePassType["Attached"] = 3] = "Attached";
})(GatePassType || (GatePassType = {}));
export var QuoteFeedbackType;
(function (QuoteFeedbackType) {
    QuoteFeedbackType[QuoteFeedbackType["PriceSeemsIncorrect"] = 1] = "PriceSeemsIncorrect";
    QuoteFeedbackType[QuoteFeedbackType["TemporaryMarketConditions"] = 2] = "TemporaryMarketConditions";
    QuoteFeedbackType[QuoteFeedbackType["MultiVehicleShipment"] = 3] = "MultiVehicleShipment";
    QuoteFeedbackType[QuoteFeedbackType["StrategicDiscounting"] = 4] = "StrategicDiscounting";
    QuoteFeedbackType[QuoteFeedbackType["CustomContractPricing"] = 5] = "CustomContractPricing";
    QuoteFeedbackType[QuoteFeedbackType["Other"] = 6] = "Other";
    QuoteFeedbackType[QuoteFeedbackType["InvalidRule"] = 7] = "InvalidRule";
    QuoteFeedbackType[QuoteFeedbackType["NewRoute"] = 8] = "NewRoute";
    QuoteFeedbackType[QuoteFeedbackType["VehicleException"] = 9] = "VehicleException";
    QuoteFeedbackType[QuoteFeedbackType["ExpeditedTimeline"] = 10] = "ExpeditedTimeline";
    QuoteFeedbackType[QuoteFeedbackType["HardRoute"] = 11] = "HardRoute";
    QuoteFeedbackType[QuoteFeedbackType["SystemError"] = 12] = "SystemError";
    QuoteFeedbackType[QuoteFeedbackType["MissingQuote"] = 13] = "MissingQuote";
    QuoteFeedbackType[QuoteFeedbackType["QuickQuote"] = 14] = "QuickQuote";
})(QuoteFeedbackType || (QuoteFeedbackType = {}));
